import { motion, AnimatePresence } from "framer-motion";
import { EASING, DURATION } from "@/lib/motionSystem";

export default function AnimatedList({
  items = [],
  renderItem,
  className = "",
  stagger = 0.07,
  animationType = "slide",
  keyField = "id",
}) {
  const getVariant = () => {
    if (animationType === "fade") {
      return { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } };
    }
    if (animationType === "scale") {
      return {
        initial: { opacity: 0, scale: 0.96 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.96 },
      };
    }
    return {
      initial: { opacity: 0, y: 12 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -8 },
    };
  };

  const variant = getVariant();

  return (
    <div className={className}>
      <AnimatePresence initial={false}>
        {items.map((item, index) => (
          <motion.div
            key={item?.[keyField] ?? `${index}-${String(item)}`}
            initial={variant.initial}
            animate={variant.animate}
            exit={variant.exit}
            transition={{
              duration: DURATION.sectionReveal * 0.5,
              delay: index * stagger,
              ease: EASING.smooth,
            }}
          >
            {renderItem(item, index)}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
